module.exports = __webpack_public_path__ + "img/dataPark5.d32d0b0c.png";